import { createContext, useContext, useState } from "react"

const GlobalContext = createContext({})

export const useGlobalContext = () => {
  return useContext(GlobalContext)
}

export default function GlobalContextProvider({ children }) {
  const [coords, setCoords] = useState({
    x: 0,
    y: 0,
  })
  const [dimentions, setDimentions] = useState({
    w: 0,
    h: 0,
  })

  return (
    <GlobalContext.Provider
      value={{ coords, setCoords, dimentions, setDimentions }}
    >
      {children}
    </GlobalContext.Provider>
  )
}
